// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2MCnO","rootSuccess":"CompleteLink_rootSuccess__22pn-","rootFailure":"CompleteLink_rootFailure__2Ee7Z","isDisabled":"CompleteLink_isDisabled__5ikrR"};